function storeFrontMenuController($scope, $rootScope, $routeSegment,
                                  imageService, merchantService, outletService,
                                  utils, helpService, $location, appConfig,
                                  appUrl, taxService, checkBrowserService,
                                  $uibModal, APP_CONSTANT,integrationConstant,
                                  integrationViewService, subscriptionService, storefrontObserverService) {
    $scope.saving = false;
    $scope.form = {};
    $scope.outletsLoaded = false;
    $scope.manageExpanded = true;
    $scope.accountancyExpanded = false;
    $scope.hasAccountancy = false;
    $scope.inventoryIsOpen = false;
    $scope.storefrontIsOpen = false;
    $scope.settingIsOpen = false;
    $scope.paymentIsOpen = false;
    $scope.adminIsOpen = false;
    $scope.isCanManageMachines = false;
    $scope.isMCAdmin = appConfig.isMCAdmin;
    $scope.dashboardInfo;
    $scope.isReportManager = appConfig.isReportManager;
    $scope.isDepartmentManager = appConfig.isDepartmentManager;
    if ($scope.isReportManager) {
        $scope.adminList = appConfig.contextPath + appUrl.reportManager;
    } else {
        $scope.adminList = appConfig.contextPath + appUrl.merchantAdmin;
    }
    $scope.username = appConfig.username;
    $scope.isMCAdmin = appConfig.isMCAdmin;
    $scope.isPartner = appConfig.isPartner;
    $scope.displayUnsupportedBrowserAlert = appConfig.displayUnsupportedBrowserAlert;
    $scope.isReportManager = appConfig.isReportManager;
    $rootScope.undefinedFamilyNumbers = 0;

    $rootScope.sideBarReturn = '/departments/'; // Put this here for the moment

    const getPermission = () => $scope.isMCAdmin || appConfig.isMerchantAdmin;

    const showRefunds = (outletInfo) => {
        const isConfigSetup = outletInfo && outletInfo.allowRefunds;
        $scope.isRefundVisible = isConfigSetup && getPermission();
    };

    // Call on page load
    $scope.init = function() {

        if ($scope.displayUnsupportedBrowserAlert) {
            if (checkBrowserService.isUnsupportedBrowser()) {
                const modalInstance = $uibModal.open({
                    template: require('../templates/browserAlertDialog.html'),
                    controller: 'BrowserAlertController',
                    windowClass: 'fade',
                    backdrop: 'static',
                    resolve: {
                    }
                });

                modalInstance.result.then((result) => {
                    if (result) {
                    }
                }, () => {});
            }
        }

        $scope.saving = false;
        $scope.$routeSegment = $routeSegment;    // Used to know what we've selected
        $rootScope.fallBackUrl = utils.checkSSL('https://qkr.azureedge.net/img/mss/product-placeholder.png');

        // Load merchant
        merchantService.loadMerchantInfo()
            .then(populateMerchantInformation);

        function populateMerchantInformation(merchantInfo) {
            $rootScope.merchantInfo = merchantInfo;


            // Update menu link for merchant's outlets
            var businessCategory = merchantInfo['businessCategory'] || {};
            var businessCategoryName = businessCategory['name'] || "";
            $scope.isCanManageMachines = businessCategoryName == APP_CONSTANT.BusinessCategory.VENDING;

            // integration settings changes
            $scope.integratrationPath = '#' + integrationConstant.LOCATION.outletAdmin.value;
            $scope.isIntegrationVisible = integrationViewService
                .isIntegrationSetAvailableForBizCat(businessCategoryName);
            // end new integration settings


            outletService.loadOutlet()
                .then(populateOutletInformation);
        }

        function populateOutletInformation(response) {
            $rootScope.outletInfo = response;
            showRefunds(response);

            const callbackTrigger = allowRefund => $scope.isRefundVisible = getPermission() && allowRefund;

            storefrontObserverService.subscribe(callbackTrigger);

            $scope.$on("$destroy", function() {
                storefrontObserverService.unsubscribe(callbackTrigger)
            });

            $rootScope.defaultCurrency = response.currencyIsoCode;

            // QKRD-2035 - we support all accountancy packages (treat them like CASES21 or Synergetic)
            $scope.hasAccountancy = response.accountancyPackage != null &&
                $rootScope.merchantInfo.accountancyPackage.name !== 'ICON';

            $scope.isProfileValidationEnabled = $scope.showDataUploadAccounting();

            // Show school fields only is business type is school

            $scope.businessSettingsName = response.businessCategoryName;

            if ($scope.businessSettingsName === 'School') {
                $scope.businessSettingsName = 'School Settings';
            } else if ($scope.businessSettingsName === 'University') {
                $scope.businessSettingsName = 'University Settings';
            } else {
                $scope.businessSettingsName = 'Business Settings';
            }

            if ($rootScope.merchantInfo.showQuest) {
                $scope.isQuest = true;
            } else {
                $scope.isQuest = false;
            }

            taxService.getTaxRatesForOutlet().then((taxRates) => {
                $rootScope.applicableTaxRates = taxRates.taxRates;
            });
        }

        helpService.loadHelp();
        $rootScope.help = helpService;

        $rootScope.undefinedFamilyNumbers = 0;
        $rootScope.undefinedProducts = 0;
        $scope.undefinedFinance1FamilyNumbers = 0;
        $scope.undefinedFinance1Products = 0;
        subscriptionService.subscribeAction(APP_CONSTANT.SubscriptionService.ACCOUNTANCY_FINANCE_NON_MATCHES_COUNT, (accountancyFinanceNonMatchesCount) => {
            $scope.undefinedFinance1FamilyNumbers = accountancyFinanceNonMatchesCount;
        });
        subscriptionService.subscribeAction(APP_CONSTANT.SubscriptionService.ACCOUNTANCY_FINANCE1_PRODUCTS_COUNT, (undefinedFinance1ProductsCount) => {
            $scope.undefinedFinance1Products = undefinedFinance1ProductsCount;
        });
    };

    $scope.showDataUploadAccounting = function() {
        return (merchantService.behaviour($rootScope.merchantInfo, 'storeFrontPage.showAccountingOptionForProfileUpload'));
    };

    $scope.showDashboardLink = function() {
        return (merchantService.behaviour($rootScope.merchantInfo, 'storeFrontPage.showDashboardLink') || $scope.isMCAdmin || $scope.isPartner);
    };

    $scope.showDeptManagement = function() {
        return merchantService.behaviour($rootScope.merchantInfo, 'storeFrontPage.showDeptManagement');
    };

    $scope.showNewMenus = function() {
        return merchantService.behaviour($rootScope.merchantInfo, 'storeFrontPage.showNewMenus');
    };

    $scope.hideCoupons = function() {
        return merchantService.behaviour($rootScope.merchantInfo, 'storeFrontPage.hideCoupons');
    };

    $scope.hideProduct = function() {
        return merchantService.behaviour($rootScope.merchantInfo, 'storeFrontPage.hideProduct');
    };

    $scope.hideMenu = function() {
        return merchantService.behaviour($rootScope.merchantInfo, 'storeFrontPage.hideMenu');
    };

    $scope.hideOptionSet = function() {
        return merchantService.behaviour($rootScope.merchantInfo, 'storeFrontPage.hideOptionSet');
    };

    $scope.showUserManagement = function() {
        return merchantService.behaviour($rootScope.merchantInfo, 'storeFrontPage.showUserManagement');
    };


    $scope.showFeatures = function() {
        return merchantService.behaviour($rootScope.merchantInfo, 'storeFrontPage.showMultiFeaturesMenu');
    };

    $scope.showDemoPosFeatures = function() {
        return merchantService.behaviour($rootScope.merchantInfo, 'storeFrontPage.showDemoPosFeatures');
    };

    $scope.showDemoPosPATFeatures = function() {
        return (merchantService.behaviour($rootScope.merchantInfo, 'storeFrontPage.showDemoPosPATFeatures')
        && $rootScope.outletInfo && $rootScope.outletInfo.payAtTableOverride);
    };

    $scope.showDemoPosBarTabFeatures = function() {
        return (merchantService.behaviour($rootScope.merchantInfo, 'storeFrontPage.showDemoPosBarTabFeatures')
        && $rootScope.outletInfo && $rootScope.outletInfo.barTabOverride);
    };

    $scope.showChangePassword = function() {
        return merchantService.behaviour($rootScope.merchantInfo, 'storeFrontPage.showChangePassword');
    };

    $scope.showStudents = function() {
        return merchantService.behaviour(merchantService.merchantInfo, 'storeFrontPage.showStudents');
    };

    $scope.showFinance1Accountancy = function() {
        return merchantService.behaviour(merchantService.merchantInfo, 'storeFrontPage.showFinance1Accountancy');
    };

    $scope.showForms = function() {
        return merchantService.behaviour(merchantService.merchantInfo, 'storeFrontPage.showForms');
    };

    $scope.showMarketing = function() {
        return merchantService.behaviour(merchantService.merchantInfo, 'storeFrontPage.showMarketing');
    };

    $scope.showForum = function() {
        let show = false;
        if ($scope.isMCAdmin && merchantService.behaviour(merchantService.merchantInfo, 'storeFrontPage.showForum')) {
            show = true;
        } else if ($rootScope.merchantInfo) {
            show = $rootScope.merchantInfo.options.showForum;
        }
        return show;
    };

    $scope.containRole = function(role) {
        return appConfig.userRoles.indexOf(role) !== -1;
    };

    $scope.checkSSL = function(imgUrl) {
        imageService.checkSSL(imgUrl);
    };

    $scope.$on('inventoryIsOpen', (evt, args) => {
        $scope.inventoryIsOpen = args;
    });

    $scope.$on('storefrontIsOpen', (evt, args) => {
        $scope.storefrontIsOpen = args;
    });

    $scope.$on('settingIsOpen', (evt, args) => {
        $scope.settingIsOpen = args;
    });

    $scope.$on('paymentIsOpen', (evt, args) => {
        $scope.paymentIsOpen = args;
    });

    $scope.$on('adminIsOpen', (evt, args) => {
        $scope.adminIsOpen = args;
    });
    
    // The product list has been reloaded
    $rootScope.$on('reloadDashboard', (evt) => {
        outletService.loadDashboardInfo().then((promise) => {
            $scope.dashboardInfo = promise;
        });
    });

    $rootScope.$on('merchantInfoChanged', (evt) => {
        outletService.refreshOutletInfo();
    });

    // Clicking Products menu on sidebar force to reload product page when user is already on product page
    $scope.loadProductsPage = function() {
        if ($routeSegment.startsWith('inventory')) {
            $routeSegment.chain[0].reload();
        } else {
            $location.path('/inventory');
        }
    };
}
angular.module('qkr').controller('StoreFrontMenuController', storeFrontMenuController);



// WEBPACK FOOTER //
// ./src/controllers/storefront.menu.controller.js